import {Box, Grid, Statistic} from '@primer/react-brand/esm'
import {clsx} from 'clsx'
import {renderWithoutParagraphs} from '../../../../utils'
import type {IntroSectionProps} from '../types'
import baseStyles from '../../../../styles/base.module.css'
import styles from '../IntroSection.module.css'

type Props = Pick<IntroSectionProps, 'introStats'>

export function IntroStats({introStats}: Props) {
  if (!introStats || introStats.length === 0) return null

  return (
    <Box className={clsx(baseStyles.cardGridFrame)}>
      <Box className={styles.statsGridContent}>
        <Grid columnGap="none" rowGap="none" enableGutters={false} className={baseStyles.gridContent}>
          {introStats.map(stat => (
            // eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals
            <Grid.Column key={stat.sys.id} span={{xsmall: 12, large: 4}} className="gridColumn">
              <Box className={clsx(baseStyles.cardGridItem, styles.statsGridItem)} padding={{narrow: 32, wide: 48}}>
                <Statistic>
                  <Statistic.Heading
                    font="monospace"
                    weight="normal"
                    size="700"
                    style={{color: 'var(--brand-color-accent-primary)'}}
                  >
                    {renderWithoutParagraphs(stat.fields.heading)}
                  </Statistic.Heading>
                  <Statistic.Description font="monospace" size="100">
                    {renderWithoutParagraphs(stat.fields.description)}
                  </Statistic.Description>
                </Statistic>
              </Box>
            </Grid.Column>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}
